module.exports = __webpack_public_path__ + "img/icon4.4dc3f0ae.png";